module.exports = __webpack_public_path__ + "static/media/Group_1000006766.2ee68fe0.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_151/img/Group_1000006766.png
// module id = 1490
// module chunks = 0